import NewRequest from './fetcher/newRequest.js'
import request from './fetcher/request'

/**
 * 获取微信公众号登录二维码
 * @param data
 * @returns {AxiosPromise<any>}
 */
export function getOfficialAccountLogin (data) {
  return NewRequest.post('/api/sdk/user/wx/mp_login', data)
}

/**
 * 微信公众号登录二维码验证
 * 当该校验码未被用户授权时，响应数据中的 data 为空
   当该校验码被用户授权成功时，响应数据中的 data 为该用户信息
 * @param data
 * @returns {AxiosPromise<any>}
 */
export function mpAuth (data) {
  return NewRequest.post('/api/sdk/user/wx/mp_auth', data)
}

/**
 * 公众号A/B test
 * @param {object} data
 * @returns {AxiosPromise<any>}
 */
export function getABTestConfig (data) {
  return request.post('/api/sdk/login/config', data)
}
